import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.log(err));

if ('serviceWorker' in navigator) {
  const baseHref = document.querySelector('base')?.getAttribute('href') || '/';
  const swUrl = `${baseHref.replace(/\/$/, '')}/service.worker.js`;
  navigator.serviceWorker.register(swUrl);
}
